module.exports = __webpack_public_path__ + "img/1699688655453.b8a777f7.jpg";